import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

export const CartProvider = ({ children }) => {
  const [lines, setLines] = useState(() => JSON.parse(localStorage.getItem("cart") || "[]"));

  useEffect(() => localStorage.setItem("cart", JSON.stringify(lines)), [lines]);

  const add = (p, qty = 1) =>
    setLines((ls) => {
      const ex = ls.find((l) => l.product_id === p.id);
      if (ex) return ls.map((l) => (l.product_id === p.id ? { ...l, quantity: Number(l.quantity) + qty } : l));
      return [...ls, { product_id: p.id, code: p.code, name: p.name, unit: p.unit, price: p.price, vat: p.vat,
        image_path: p.image_path, image_url: p.image_url, quantity: qty, discount: 0, discount_type: "percent" }];
    });
  const update = (id, patch) => setLines((ls) => ls.map((l) => (l.product_id === id ? { ...l, ...patch } : l)));
  const remove = (id) => setLines((ls) => ls.filter((l) => l.product_id !== id));
  const clear = () => setLines([]);

  return <CartCtx.Provider value={{ lines, add, update, remove, clear }}>{children}</CartCtx.Provider>;
};

export const useCart = () => useContext(CartCtx);
